const errorClassName = "countable-input--error";

export default Object.freeze(
  function countableInput(inputElement, outputElement, maximumNumberOfCharacters) {
    const updateOutputElement = function () {
      outputElement.innerText = outputText();
    };

    const outputText = function () {
      const plural = characterNumber() !== 1 ? "s" : "";
      return `${characterNumber()}/${maximumNumberOfCharacters} character${plural}`;
    };

    const characterNumber = () => inputElement.value.length;

    const toggleClasses = function () {
      inputElement.classList.toggle(errorClassName, characterNumberExcedeed());
      outputElement.classList.toggle(errorClassName, characterNumberExcedeed());
    };

    const characterNumberExcedeed = () => characterNumber() > maximumNumberOfCharacters;

    updateOutputElement();
    toggleClasses();

    inputElement.addEventListener("input", function () {
      updateOutputElement();
      toggleClasses();
    });
  }
);
